<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <div class="d-flex justify-content-between">
        <h3>الفعاليات</h3>
        <b-button
          variant="success"
          @click="isModalVisible = true"
          v-can="{ slug: $route.meta.slug, action: 'C' }"
        >
          <feather-icon icon="PlusIcon" />
          إضافة</b-button
        >
      </div>
      <hr />
      <div
        v-if="events.length > 0"
        v-can="{ slug: $route.meta.slug, action: 'S' }"
      >
        <event-card
          v-for="(item, i) in events"
          :info="item"
          :key="i"
          :page.sync="currentPage"
          @editClicked="openEditEventModal"
          @deleteClicked="deleteEvent({ id: item.id, page: currentPage })"
        />
      </div>
      <alert massage="عذراً لا يوجد سجلات لعرضها" class="w-100" v-else></alert>

      <form-modal
        v-model="isModalVisible"
        title="معلومات الفعالية"
        :formSchema="formSchema"
        ref="eventModal"
        @confirm="handleEventSubmit"
        :loading="working"
      />

      <pagination
        v-can="{ slug: $route.meta.slug, action: 'S' }"
        class="mt-2"
        v-model="currentPage"
        :total-rows="pagination.total_row"
        :per-page="pagination.per_page"
        align="end"
      >
      </pagination>
    </div>
  </b-card>
</template>
<script>
import { BCard, BButton, BSpinner } from "bootstrap-vue";
import EventCard from "@/modules/ngo/guest-pages-management/components/EventCard";
import { mapActions, mapGetters } from "vuex";
import Pagination from "@/components/pagination";
import Alert from "@/components/Alert.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import FormModal from "@/components/FormModal.vue";
export default {
  components: {
    BCard,
    BButton,
    EventCard,
    Pagination,
    BSpinner,
    Alert,
    LoadingOverlay,
    FormModal,
  },
  data() {
    return {
      currentPage: 1,
      isModalVisible: false,
      formSchema: {
        image_event: {
          component: "FormImageInput",
          key: "image_event",
          attrs: {
            label: "صورة الفعالية",
            id: "form-image",
            name: "image",
          },
        },
        title_ar: {
          component: "FormInput",
          key: "title_ar",
          attrs: {
            label: "اسم الفعالية",
            rules: "required",
          },
        },
        invitation_type: {
          component: "FormSelect",
          key: "invitation_type",
          attrs: {
            label: "نوع الدعوة",
            id: "invitation-type",
            reduce: (x) => x.value,
            getOptionLabel: (x) => x.title,
            rules: "required",
            options: [
              { value: 1, title: "عامة" },
              { value: 0, title: "خاصة" },
            ],
          },
        },
        event_type_id: {
          component: "FormSelect",
          key: "event_type_id",
          attrs: {
            label: "نوع الفعالية",
            id: "event-type",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.title_ar,
            rules: "required",
            ep: "v2/guest/selects/event-types",
          },
        },
        from_event_date: {
          component: "FormMask",
          key: "from_event_date",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ بداية الفعالية",
            rules: "required",
          },
        },
        to_event_date: {
          component: "FormMask",
          key: "to_event_date",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ نهاية الفعالية",
            rules: "required",
          },
        },
        from_event_duration: {
          component: "FormMask",
          key: "from_event_duration",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ الإعلان عن الفعالية",
            rules: "required",
          },
        },
        to_event_duration: {
          component: "FormMask",
          key: "to_event_duration",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ نهاية الإعلان الفعالية",
            rules: "required",
          },
        },
        from_time: {
          component: "FormMask",
          key: "from_time",
          attrs: {
            options: "time",
            placeholder: "د : س",
            label: "توقيت بداية الفعالية",
            rules: "required",
          },
        },
        to_time: {
          component: "FormMask",
          key: "to_time",
          attrs: {
            options: "time",
            placeholder: "د : س",
            label: "توقيت نهاية الفعالية",
            rules: "required",
          },
        },
        location: {
          component: "FormInput",
          key: "location",
          attrs: {
            label: "العنوان",
            rules: "required",
          },
        },
        description_ar: {
          component: "FormTextarea",
          key: "description_ar",
          attrs: {
            label: "التفاصيل",
            rules: "required",
          },
        },
        link: {
          component: "FormInput",
          key: "link",
          attrs: {
            label: "رابط الفعالية",
            rules: "required|url",
          },
        },
      },
    };
  },
  methods: {
    ...mapActions("Ministry/Settings/Events", [
      "createEvent",
      "updateEvent",
      "getEvents",
      "deleteEvent",
    ]),
    openEditEventModal(form) {
      var toUpdate = { ...form };
      toUpdate.event_type_id = form.eventType ? form.eventType.id : null;
      delete toUpdate.eventType;

      this.$refs.eventModal.init(toUpdate);
      this.isModalVisible = true;
    },
    handleEventSubmit(form) {
      if (form.id) {
        this.updateEvent({ form, page: this.currentPage }).then(() => {
          this.isModalVisible = false;
        });
      } else {
        this.createEvent({ form, page: this.currentPage }).then(() => {
          this.isModalVisible = false;
        });
      }
    },
  },
  computed: {
    ...mapGetters("Ministry/Settings/Events", [
      "events",
      "loading",
      "pagination",
      "working",
    ]),
  },
  watch: {
    currentPage(value) {
      this.getEvents({ page: value });
    },
  },
  created() {
    this.getEvents({ page: this.currentPage });
  },
};
</script>
